import { useEffect } from 'react';
import {
  resetAdminCampaigns,
  resetAdminDatasets,
  resetAdminSchedules,
} from 'features/admin-campaigns/slice';
import { useAppDispatch } from 'store/hooks';

export function useResetAdminDataOnUnmountEffect() {
  const dispatch = useAppDispatch();

  useEffect(
    () => () => {
      dispatch(resetAdminCampaigns());
      dispatch(resetAdminDatasets());
      dispatch(resetAdminSchedules());
    },
    [dispatch]
  );
}
